export class SaasClaudeEnterpriseMembership {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationName",
            "baseName": "organizationName",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasClaudeEnterpriseMembership.attributeTypeMap;
    }
    constructor() {
    }
}
